import Vue from 'vue';
import ElementUI from '@/components/element';
import Module from '@/components/Module.vue';
import Table from '@/components/Table.vue';
import FormWrap from '@/components/FormWrap.vue';
import i18n from '@/i18n';
import '@/styles/index.scss';
import '@/styles/element.scss';
import '@/mixins';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.use(ElementUI);

// 全局组件
Vue.component('Module', Module);
Vue.component('Table', Table);
Vue.component('FormWrap', FormWrap);

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
